// students/new-list
import React, { useCallback, useState, useMemo } from 'react';
import View from 'src/pages/officers/courses/assign-students';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { studentApi } from 'src/api/students/vm-view';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
  
  const [data, setData] = useState(null);
  const fetchData = useCallback(async () => {
    if (!itemNavigate) return;
    return studentApi.getNewUnlimitedList(itemNavigate, setData);
  }, [itemNavigate]);

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} />}
    </AppRender>
  );
};

export default Page;
